import _ from 'lodash/fp';
import { connect } from 'react-redux';
import { compose, withProps, branch, renderNothing } from 'recompose';
import { actions } from '../../reducers';

const mapStateToProps = state => ({
  eventIds: _.sortBy(
    id => state.collections.events[id].startDate,
    _.keys(state.collections.events)
  )
});

const mapDispatchToProps = {
  fetch: actions.collections.fetch
};

const createProps = props => ({
  fetch: () => {
    props.fetch('events');
    props.fetch('content');
  }
});

const nothingWhileLoading = hasLoaded =>
  branch(props => !hasLoaded(props), renderNothing);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(createProps)
);



// WEBPACK FOOTER //
// ./src/components/schedule/enhance.js